import { FRONT_APP, FRONT_APP_COMPLETED_ITEMS, FRONT_APP_COMPLETED_ITEMS_SUCCESS, FRONT_APP_FAILURE, FRONT_APP_SUCCESS, UPDATE_COMMENT, UPDATE_COMMENT_SUCCESS, UPDATE_DT_PM, UPDATE_DT_PM_SUCCESS, UPDATE_BULK_DT_PM, UPDATE_BULK_DT_PM_SUCCESS, UPDATE_FOLDER_NUMBER, UPDATE_FOLDER_NUMBER_SUCCESS, UPDATE_FRONTAPP_ROW, UPDATE_PROJECT_NAME, UPDATE_PROJECT_NAME_SUCCESS, UPDATE_WORKER, UPDATE_WORKER_SUCCESS, START_FRONTAPP_TIMER, START_FRONTAPP_TIMER_SUCCESS, PAUSE_FRONTAPP_TIMER, PAUSE_FRONTAPP_TIMER_SUCCESS, RESUME_FRONTAPP_TIMER, RESUME_FRONTAPP_TIMER_SUCCESS, GET_FRONTAPP_TIMER_STATUS, GET_FRONTAPP_TIMER_STATUS_SUCCESS, GET_CA_PHASE_TASKS, GET_CA_PHASE_TASKS_SUCCESS, GET_CA_PHASE_TASKS_FAILURE, UPDATE_CA_PHASE_TASKS, UPDATE_CA_PHASE_TASKS_SUCCESS, UPDATE_CA_PHASE_TASKS_FAILURE, GET_RUNNING_FRONTAPP_TASK, GET_RUNNING_FRONTAPP_TASK_SUCCESS, GET_RUNNING_FRONTAPP_TASK_FAILURE } from "../storeTypes";

export const getAllFrontapp = (payload,) => {
    return {
        type: FRONT_APP,
        payload: payload,
        // Callback
    }
};
export const getAllFrontappSucess = (payload) => {
    return {
        type: FRONT_APP_SUCCESS,
        payload: payload,
    }
};
export const getFrontappCompleted = (payload) => {
    return {
        type: FRONT_APP_COMPLETED_ITEMS,
        payload: payload,
    }
}
export const getFrontappCompletedSuccess = (payload) => {
    return {
        type: FRONT_APP_COMPLETED_ITEMS_SUCCESS,
        payload: payload,
    }
}
export const UpdateFrontAppRow = (payload) => {
    return {
        type: UPDATE_FRONTAPP_ROW,
        payload: payload,
    }
}
export const updateDTPM = (payload, id) => {
    return {
        type: UPDATE_DT_PM,
        payload,
        id
    }
}
export const updateDTPMSuccess = (payload, id) => {
    return {
        type: UPDATE_DT_PM_SUCCESS,
        payload: payload,
        id
    }
}

export const updateBulkDTPM = (payload, callback) => {
    return {
        type: UPDATE_BULK_DT_PM,
        payload,
        callback
    }
}
export const updateBulkDTPMSuccess = (payload) => {
    return {
        type: UPDATE_BULK_DT_PM_SUCCESS,
        payload: payload,
    }
}

export const updateComment = (payload, id) => {
    return {
        type: UPDATE_COMMENT,
        payload,
        id
    }
}
export const updateCommentSuccess = (payload, id) => {
    // console.log("Updatepayload", payload);
    return {
        type: UPDATE_COMMENT_SUCCESS,
        payload: payload,
        id
    }
}
export const updateFolder = (payload, id) => {
    return {
        type: UPDATE_FOLDER_NUMBER,
        payload,
        id
    }
}
export const updateFolderSuccess = (payload) => {
    return {
        type: UPDATE_FOLDER_NUMBER_SUCCESS,
        payload: payload
    }
}

export const updateProjectName = (payload, id) => {
    return {
        type: UPDATE_PROJECT_NAME,
        payload,
        id
    }
}
export const updateProjectNameSuccess = (payload, id) => {
    return {
        type: UPDATE_PROJECT_NAME_SUCCESS,
        payload: payload,
        id
    }
}

export const updateWorker = (payload, id) => {
    return {
        type: UPDATE_WORKER,
        payload,
        id
    }
}
export const updateWorkerSuccess = (payload) => {
    return {
        type: UPDATE_WORKER_SUCCESS,
        payload: payload
    }
}

export const frontAppFailure = (error) => {
    return {
        type: FRONT_APP_FAILURE,
        payload: error
    }
}

// FrontApp Timer Actions
export const startFrontAppTimer = (id, callback) => {
    return {
        type: START_FRONTAPP_TIMER,
        id,
        callback
    }
};
export const startFrontAppTimerSuccess = (payload) => {
    return {
        type: START_FRONTAPP_TIMER_SUCCESS,
        payload
    }
};
export const pauseFrontAppTimer = (id, callback, skipRefetch = false) => {
    return {
        type: PAUSE_FRONTAPP_TIMER,
        id,
        callback,
        skipRefetch
    }
};
export const pauseFrontAppTimerSuccess = (payload) => {
    return {
        type: PAUSE_FRONTAPP_TIMER_SUCCESS,
        payload
    }
};
export const resumeFrontAppTimer = (id, callback) => {
    return {
        type: RESUME_FRONTAPP_TIMER,
        id,
        callback
    }
};
export const resumeFrontAppTimerSuccess = (payload) => {
    return {
        type: RESUME_FRONTAPP_TIMER_SUCCESS,
        payload
    }
};

export const getFrontAppTimerStatus = (id) => {
    return {
        type: GET_FRONTAPP_TIMER_STATUS,
        id
    }
};
export const getFrontAppTimerStatusSuccess = (payload) => {
    return {
        type: GET_FRONTAPP_TIMER_STATUS_SUCCESS,
        payload
    }
};

export const getCaPhaseTasks = (id, page = 1, limit = 15, callback, isSilent = false) => {
    return {
        type: GET_CA_PHASE_TASKS,
        id,
        page,
        limit,
        callback,
        isSilent
    }
};
export const getCaPhaseTasksSuccess = (payload) => {
    return {
        type: GET_CA_PHASE_TASKS_SUCCESS,
        payload
    }
};
export const getCaPhaseTasksFailure = (error) => {
    return {
        type: GET_CA_PHASE_TASKS_FAILURE,
        payload: error
    }
};

export const updateCaPhaseTasks = (projectId, id, payload, callback, isSilent = false) => {
    return {
        type: UPDATE_CA_PHASE_TASKS,
        projectId,
        id,
        payload,
        callback,
        isSilent
    }
};
export const updateCaPhaseTasksSuccess = (payload) => {
    return {
        type: UPDATE_CA_PHASE_TASKS_SUCCESS,
        payload
    }
};
export const updateCaPhaseTasksFailure = (error) => {
    return {
        type: UPDATE_CA_PHASE_TASKS_FAILURE,
        payload: error
    }
};

export const getRunningFrontAppTask = (callback) => {
    return {
        type: GET_RUNNING_FRONTAPP_TASK,
        callback
    }
};
export const getRunningFrontAppTaskSuccess = (payload) => {
    return {
        type: GET_RUNNING_FRONTAPP_TASK_SUCCESS,
        payload
    }
};
export const getRunningFrontAppTaskFailure = (error) => {
    return {
        type: GET_RUNNING_FRONTAPP_TASK_FAILURE,
        payload: error
    }
};
